import {
  IAddServiceMethodRequest,
  IAssignPermissionsRequest,
  IBatchAddServiceMethodsRequest,
  ICreateUpdateNavigationRequest,
} from '../../types/api/request/navigationrequest';
import {
  IBatchAddServiceMethodResponse,
  IGetAllNavigationsResponse,
  INavigationPermissionResponse,
  INavigationServiceMethodResponse,
} from '../../types/api/response/navigationresponse';
import axiosClient from '../axiosClient';
import { NavigationEndpoints } from '../endpoints/navigation';

export const NavigationService = {
  async getAllNavigations(): Promise<IGetAllNavigationsResponse> {
    const res = await axiosClient.get<IGetAllNavigationsResponse>(
      NavigationEndpoints.GET_ALL_NAVIGATIONS,
    );
    return res.data;
  },

  async getNavigationById(id: number) {
    const url = NavigationEndpoints.GET_NAVIGATION_BY_ID.replace(':id', id.toString());
    const res = await axiosClient.get(url);
    return res.data;
  },

  async createNavigation(payload: ICreateUpdateNavigationRequest) {
    const res = await axiosClient.post(NavigationEndpoints.CREATE_NAVIGATION, payload);
    return res.data;
  },

  async updateNavigation(payload: ICreateUpdateNavigationRequest, id: number) {
    const url = NavigationEndpoints.UPDATE_NAVIGATION.replace(':id', id.toString());
    const res = await axiosClient.put(url, payload);
    return res.data;
  },

  async deleteNavigation(id: number) {
    const url = NavigationEndpoints.DELETE_NAVIGATION.replace(':id', id.toString());
    const res = await axiosClient.delete(url);
    return res.data;
  },

  async getNavigationPermissions(id: number): Promise<INavigationPermissionResponse[]> {
    const url = NavigationEndpoints.GET_NAVIGATION_PERMISSIONS.replace(':id', id.toString());
    const res = await axiosClient.get<INavigationPermissionResponse[]>(url);
    return res.data;
  },

  async assignPermissions(id: number, payload: IAssignPermissionsRequest) {
    const url = NavigationEndpoints.ASSIGN_NAVIGATION_PERMISSIONS.replace(':id', id.toString());
    const res = await axiosClient.post(url, payload);
    return res.data;
  },

  async removePermission(id: number, permissionId: number) {
    const url = NavigationEndpoints.REMOVE_NAVIGATION_PERMISSION.replace(
      ':id',
      id.toString(),
    ).replace(':permissionId', permissionId.toString());
    const res = await axiosClient.delete(url);
    return res.data;
  },

  async getServiceMethods(id: number): Promise<INavigationServiceMethodResponse[]> {
    const url = NavigationEndpoints.GET_SERVICE_METHODS.replace(':id', id.toString());
    const res = await axiosClient.get<INavigationServiceMethodResponse[]>(url);
    return res.data;
  },

  async addServiceMethod(
    id: number,
    payload: IAddServiceMethodRequest,
  ): Promise<INavigationServiceMethodResponse> {
    const url = NavigationEndpoints.ADD_SERVICE_METHOD.replace(':id', id.toString());
    const res = await axiosClient.post<INavigationServiceMethodResponse>(url, payload);
    return res.data;
  },

  async batchAddServiceMethods(
    id: number,
    payload: IBatchAddServiceMethodsRequest,
  ): Promise<IBatchAddServiceMethodResponse> {
    const url = NavigationEndpoints.BATCH_ADD_SERVICE_METHODS.replace(':id', id.toString());
    const res = await axiosClient.post<IBatchAddServiceMethodResponse>(url, payload);
    return res.data;
  },

  async removeServiceMethod(id: number, serviceMethodId: number) {
    const url = NavigationEndpoints.REMOVE_SERVICE_METHOD.replace(':id', id.toString()).replace(
      ':serviceMethodId',
      serviceMethodId.toString(),
    );
    const res = await axiosClient.delete(url);
    return res.data;
  },
};
